import { useContext } from 'react';
import { IdleTimerContext } from '../contexts/IdleTimerContext';

export const useIdleTimer = () => {
  const context = useContext(IdleTimerContext);
  if (!context) {
    throw new Error('useIdleTimer must be used within IdleTimerProvider');
  }
  return context;
};